import React from 'react'
import PageTitle from '../components/PageTitle/PageTitle';
import Register1 from '../components/UI/Register1';

const Register = () => {
  return (
    <PageTitle title="Register">  
       <Register1/>
    </PageTitle>
  );
};

export default Register